import { useState } from 'react';
import { X } from 'lucide-react';

export default function NewTicketModal({ onClose, onCreate }) {
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !text.trim()) return;
    setLoading(true);
    try {
      await onCreate(title.trim(), text.trim());
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(3px)', zIndex: 60, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
      data-testid="new-ticket-modal-backdrop"
    >
      <div
        style={{ background: '#141419', border: '1px solid #1f1f2e', borderRadius: 14, width: '100%', maxWidth: 540, padding: 28 }}
        data-testid="new-ticket-modal"
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <div>
            <h2 style={{ color: '#f4f4f5', fontSize: 18, fontWeight: 700, margin: 0 }}>New Ticket</h2>
            <p style={{ color: '#52525b', fontSize: 13, margin: '4px 0 0' }}>Add a requirement for risk analysis</p>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', color: '#52525b', cursor: 'pointer', padding: 4 }}
            data-testid="modal-close-btn"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', color: '#a1a1aa', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>
              Title
            </label>
            <input
              data-testid="ticket-title-input"
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="e.g. Medication Administration Order"
              style={{ width: '100%', background: '#0d0d12', border: '1px solid #2a2a3a', borderRadius: 8, padding: '10px 14px', color: '#f4f4f5', fontSize: 14, outline: 'none', fontFamily: 'inherit' }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', color: '#a1a1aa', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 8 }}>
              Requirement Text
            </label>
            <textarea
              data-testid="ticket-text-input"
              value={text}
              onChange={e => setText(e.target.value)}
              rows={7}
              placeholder="Paste your requirement, SOP, circular, PRD, or contract clause here..."
              style={{ width: '100%', background: '#0d0d12', border: '1px solid #2a2a3a', borderRadius: 8, padding: '10px 14px', color: '#f4f4f5', fontSize: 13, lineHeight: 1.6, outline: 'none', resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button
              type="submit"
              disabled={loading || !title.trim() || !text.trim()}
              data-testid="add-to-backlog-btn"
              style={{
                flex: 1, background: loading ? '#4f46e5' : '#6366f1', border: 'none', borderRadius: 8,
                padding: '10px 20px', color: '#fff', fontSize: 14, fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
                fontFamily: 'inherit', transition: 'background 0.2s',
                boxShadow: '0 0 14px rgba(99,102,241,0.3)',
                opacity: (!title.trim() || !text.trim()) ? 0.5 : 1,
              }}
            >
              {loading ? 'Adding...' : 'Add to Backlog'}
            </button>
            <button
              type="button"
              onClick={onClose}
              style={{ background: 'none', border: 'none', color: '#52525b', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}
              data-testid="modal-cancel-btn"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
